
export const dataChart = [
    {
        id: 1,
        name: 'Reserve Fund',
        numb: '40%',
    },
    {
        id: 2,
        name: 'Team & Advisor',
        numb: '30%',
    },
    {
        id: 3,
        name: 'Presale Token',
        numb: '10%',
    },
    {
        id: 4,
        name: 'Bounty Program',
        numb: '10%',
    },
    {
        id: 5,
        name: 'Bounty Program',
        numb: '10%',
    },
    {
        id: 6,
        name: 'Product Development',
        numb: '40%',
    },
    {
        id: 7,
        name: 'Marketing',
        numb: '30%',
    },
    {
        id: 8,
        name: 'Business Development',
        numb: '10%',
    },
    {
        id: 9,
        name: 'Legal & Regulation',
        numb: '10%',
    },
    {
        id: 10,
        name: 'Operational',
        numb: '10%',
    },
]

export default dataChart;